<!--
  TODO
  * Bugs when removing long ones (width/position doesn't update) (if at not beginning -> reset to beginning if "not active"?)
  * Removing first item glitches IF slider is active (many items) (pos change issue?) (or views not loading correct ones - fix that first)
  * Fix sliders size / scrolling issue with lots of items
    * They also overflow incorrectly when adding new filters, slider size doesn't update
  * Max-width to filter?
  * Fix all viewports
  * Slider bugs cause stuff is loaded 4x times? Yes -> seems to work _when_ all items are identical (cause API doesnt return empty ones?)
  * This also loads again when F5 @ overview -> datasets/pdfs.. [NOTE: Only bugs at local? Seems to work nicely at production/io?]
-->
<template>
  <div class="query">
    <div
      :class="['query__button', 'query__button--left', leftActive ? '' : 'query__button--inactive']"
      @click="pushFilters('toRight')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>
    </div>

    <div
      ref="querySlider"
      id="querySlider"
      class="query__content"
    >
      <div
        ref="querySliderItems"
        id="querySliderItems"
        :style="'margin-left:' + drag.current + 'px'"
        :class="[pushed ? 'query__filters--transition' : '']"
      >
        <transition-group
          name="query__transition"
          tag="div"
          class="query__filters"
          appear
        >
          <div
            v-if="totalSelectedFilters >= 5"
            key="FILTER_QUERY_ITEM_TITLE"
            :class="['query__title', totalSelectedFilters === 0 ? 'query__title--active' : '']"
          >
            <p v-html="totalSelectedFilters > 0 ? (windowWidth < 640 ? '(<span>' : 'Filters (<span>') + totalSelectedFilters + '</span>)' : ''" />
          </div>

          <template v-for="item in queryItems">
            <template v-if="!item.attributes.initializing || item.attributes.initializing === false">
              <div
                v-if="item.type === 'operator'"
                :key="'OPERATOR_' + item.id"
                class="query__operator query__transition-item"
              >
                <p>{{ item.attributes.name }}</p> <!-- + / @ small viewports -->
              </div>

              <UtilityFilter
                v-else
                :ref="'querySliderItem--' + item.id"
                :key="'FILTER_' + item.type + '_' + item.attributes.condition + '_' + item.id"
                class="query__filter query__transition-item"
                :value="item"
                :disabled="isFilterDisabled(item)"
                @removed="removeFilter(item)"
              />
            </template>
          </template>

          <FormButton
            v-if="!initializing && totalSelectedFilters > 0"
            key="FILTERS__REMOVE"
            class="query__controls query__transition-item"
            size="sm"
            variant="dark"
            :circle="true"
            :borderless="true"
            color="blue"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5 15.538l-3.592-3.548 3.546-3.587-1.416-1.403-3.545 3.589-3.588-3.543-1.405 1.405 3.593 3.552-3.547 3.592 1.405 1.405 3.555-3.596 3.591 3.55 1.403-1.416z"/></svg>'
            iconSize="lg"
            content="<u>Remove</u> <i>all</i> filters"
            v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
            @click.native="resetSearch()"
          />
        </transition-group>
      </div>
    </div>

    <div
      :class="['query__button', 'query__button--right', rightActive ? '' : 'query__button--inactive']"
      @click="pushFilters('toLeft')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>
    </div>
  </div>
</template>

<script>
import FormButton from '@/components/form/Button.vue'
import UtilityFilter from '@/components/utility/Filter.vue'
import config from '@/helpers/config'
import helperMethods from '@/helpers/utility'

export default {
  components: {
    FormButton,
    UtilityFilter
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      initializing: true,
      mounted: false,
      pushed: false,
      drag: {
        current: 0,
        x: 0,
        dragging: false,
        preventToggle: false
      }
    }
  },
  computed: {
    selectedFilters () {
      return this.$store.getters['search/getSelectedFilters']
    },
    totalSelectedFilters () {
      let total = 0

      if (this.selectedFilters) {
        for (const [key, value] of Object.entries(this.selectedFilters)) {
          if (this.selectedFilters[key] && this.selectedFilters[key].length > 0) {
            total += this.selectedFilters[key].length
          }
        }
      }

      return total
    },
    queryItems () {
      let items = []
      let initialized = false
      let previousType = false
      let previousFilter = false
      let operatorName = false

      for (const [groupKey, group] of Object.entries(this.selectedFilters)) {
        if (group.length > 0) {
          for (const [key, filter] of Object.entries(group)) {
            if (filter.id && (!filter.attributes.initializing || filter.attributes.initializing === false)) {
              if (previousType === 'published') {
                operatorName = 'AND'
              } else {
                operatorName = previousType === filter.type ? 'OR' : 'AND'
              }

              let operator = { 'id': filter.type + '_' + filter.attributes.condition + '_' + filter.id, 'type': 'operator', 'attributes': { 'name': operatorName, 'condition': '' }}
              items.push(operator)
              items.push(filter)
            } else {
              initialized = true
            }

            previousType = groupKey
            previousFilter = filter
          }
        }
      }

      if (initialized === false) {
        this.initializing = false
      }

      items.shift()
      return items
    },
    leftActive () {
      if (this.mounted) {
        let check = this.drag.current < 0 ? true : false
        return check
      }

      return true
    },
    rightActive () {
      if (this.mounted) {
        let check = (this.$refs.querySliderItems.offsetWidth + this.drag.current) > this.$refs.querySlider.clientWidth ? true : false
        return check
      }

      return true
    }
  },
  methods: {
    isFilterDisabled (value) {
      let view = this.getSearchView()

      if (value.type === 'queries') {
        return false
      }

      if (config.filterFields[view]) {
        for (const filter of config.filterFields[view]) {
          if (value.type === filter.key) {
            return false
          }
        }
      }

      return true
    },
    resetSearch () {
      window.scrollTo(0,0)
      let views = ['search', 'datasets', 'pdfs', 'news']
      let currentView = this.$route.name.toLowerCase()
      let view = '/'

      if (views.includes(currentView)) {
        view = currentView === 'search' ? '/' : '/' + currentView
      }

      this.$store.dispatch('search/resetState')
      this.$router.push(view)
    },
    removeFilter (value) {
      window.scrollTo(0,0)
      let type = value.type
      let filters = this.selectedFilters
      let views = ['search', 'datasets', 'pdfs', 'news']
      let view = false
      let path = '/'

      if ((this.$refs.querySliderItems.offsetWidth + this.drag.current) <= this.$refs.querySlider.clientWidth) {
        let filterWidth = this.$refs['querySliderItem--' + value.id][0].$el.offsetWidth
        this.dragFilters(filterWidth + 8)
      }

      let key = this.itemFound(value, filters[type])
      filters[type].splice(key, 1)
      this.$store.dispatch('search/setSelectedFilters', filters)

      if (views.includes(this.$route.name.toLowerCase())) {
        view = this.$route.name.toLowerCase()
        path = '/' + view

        if (this.totalSelectedFilters === 0) {
          path = view === 'search' ? '/' : '/' + view
        }
      } else if (['dataset', 'pdf'].includes(this.$route.name.toLowerCase())) {
        if (this.$route.name.toLowerCase() === 'dataset') {
          view = 'datasets'
        } else if (this.$route.name.toLowerCase() === 'pdf') {
          view = 'pdfs'
        }

        path = '/' + view

        if (this.totalSelectedFilters === 0) {
          path = view === 'search' ? '/' : '/' + view
        }
      }

      this.$store.dispatch('app/setSettings', { 'name': 'search.view', 'value': view })
      this.$store.dispatch('search/setPageNumber', { type: view, value: 1 })

      this.$router.push(path + '?' + this.$store.getters['search/getFiltersQuery'](view, 'search') + this.$store.getters['search/getControlsQuery'](view, 'search'))
    },
    pushFilters (direction) {
      this.pushed = true
      let newXPos = 0

      if (direction === 'toLeft') {
        newXPos = this.drag.x - this.$refs.querySlider.clientWidth + 40
      } else if (direction === 'toRight') {
        newXPos = this.drag.x + this.$refs.querySlider.clientWidth - 40
      }

      this.dragFilters(newXPos)

      setTimeout(function () {
        this.pushed = false
      }.bind(this), 600)
    },
    dragFilters (xPos) {
      if (this.$refs.querySliderItems.offsetWidth > this.$refs.querySlider.clientWidth) {
        if (this.drag.current + xPos - this.drag.x > 0) {
          this.drag.current = 0
          this.drag.x = xPos
        } else if (this.drag.current + xPos - this.drag.x < this.$refs.querySlider.clientWidth - this.$refs.querySliderItems.offsetWidth) {
          this.drag.current = this.$refs.querySlider.clientWidth - this.$refs.querySliderItems.offsetWidth
          this.drag.x = xPos
        } else {
          this.drag.current = this.drag.current + xPos - this.drag.x
          this.drag.x = xPos
        }
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    ...helperMethods
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)

      document.getElementById('querySlider').addEventListener('mousedown', e => {
        this.drag.x = e.clientX
        this.drag.dragging = true
        let that = this

        setTimeout(function () {
          if (that.drag.dragging === true) {
            that.drag.preventToggle = true
          }
        }, 500)
      }, { passive: true})

      document.getElementById('querySlider').addEventListener('touchstart', e => {
        if (e.targetTouches[0]) {
          this.drag.x = e.targetTouches[0].pageX
          this.drag.dragging = true
        }
      }, { passive: true})

      window.addEventListener('mousemove', e => {
        if (this.drag.dragging === true) {
          this.dragFilters(e.clientX)
        } else {
          this.drag.preventToggle = false
        }
      }, { passive: true})

      window.addEventListener('mouseup', e => {
        if (this.drag.dragging === true) {
          this.dragFilters(e.clientX)
          this.drag.x = 0
          this.drag.dragging = false
          let that = this

          setTimeout(function () {
            that.drag.preventToggle = false
          }, 10)
        }
      }, { passive: true})

      window.addEventListener('touchmove', e => {
        if (e.targetTouches[0]) {
          if (this.drag.dragging === true) {
            this.dragFilters(e.targetTouches[0].pageX)
          } else {
            this.drag.preventToggle = false
          }
        }
      }, { passive: true})

      window.addEventListener('touchend', e => {
        if (e.targetTouches[0]) {
          if (this.drag.dragging === true) {
            this.dragFilters(e.targetTouches[0].pageX)
            this.drag.x = 0
          }
        }
        this.drag.dragging = false
      }, { passive: true})

      this.mounted = true
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.nextItem)
    window.removeEventListener('mousedown', this.nextItem)
    window.removeEventListener('mouseup', this.nextItem)
    window.removeEventListener('mousemove', this.nextItem)
    window.removeEventListener('touchstart', this.nextItem)
    window.removeEventListener('touchend', this.nextItem)
    window.removeEventListener('touchmove', this.nextItem)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.query {
  @include font('content--sm');
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  width: 100%;
  user-select: none;

  &:hover {
    .query__button {
      fill: rgba($white, 0.1);
      background-color: $bg-2;
    }

    .query__button:not(.query__button--inactive) {
      fill: rgba($white, 0.7);
    }
  }

  &__title, &__operator {
    @include font('content--xs', $white, 0.5);
    position: relative;
    z-index: 9;
    font-weight: 500;
    margin: 0px 3px;
    text-transform: uppercase;
    display: inline-flex;

    /deep/ span {
      color: rgba($white, 0.7) !important;
    }

    &--active {
      color: rgba($white, 0.7);
    }
  }

  &__filter {
    position: relative;
    z-index: 10;
  }

  &__title {
    margin: 0px 8px 0px 8px;
  }

  &__controls {
    margin: 0 4px 0 2px;
  }

  &__button {
    display: flex;
    border-radius: 999px;
    align-items: center;
    user-select: none;
    padding: 7px 8px 9px 8px;
    transition: background-color 0.2s ease-out;
    background-color: $bg-4;
    fill: $bg-2;

    &:hover:not(.query__button--inactive) {
      fill: $white !important;
      cursor: pointer;

      svg {
        transform: scale(1.15);
      }
    }

    &:focus, &:active {
      svg {
        transform: scale(1) !important;
      }
    }

    &--left {
      transform: rotate(270deg);
      margin: 0px 2px 0px 0px;

    }

    &--right {
      transform: rotate(90deg);
      margin: 0px 0px 0px 2px;
    }

    svg {
      transition: fill 0.2s ease-out;
      width: 14px;
      height: 14px;

      @media screen and (min-width: $breakpointLg) {
        width: 16px;
        height: 16px;
      }
    }
  }

  &__content {
    position: relative;
    z-index: 5;
    flex: 1;
    height: 36px;
    display: flex;
    overflow: hidden;
    white-space: nowrap;
    border-radius: 999px;
    transition: background-color 0.2s ease-out;
    background-color: $bg-4;
    cursor: col-resize;

    &--centered {
      justify-content: center;
    }
  }

  &__filters {
    height: 36px;
    display: inline-flex;
    align-items: center;

    &--transition {
      transition: margin 0.3 ease-in-out;

      @media screen and (min-width: $breakpointSm) {
        transition: margin 0.4s ease-in-out;
      }

      @media screen and (min-width: $breakpointMd) {
        transition: margin 0.5s ease-in-out;
      }

      @media screen and (min-width: $breakpointLg) {
        transition: margin 0.6s ease-in-out;
      }
    }
  }
}

.query__transition-item {
  position: relative;
  transition: all 0.3s ease-out;
}
.query__transition-enter {
  opacity: 0;
  transform: translateY(-12px);
}
.query__transition-enter-active {
  //transition: all 0.3s ease-in;
}
.query__transition-leave-to {
  opacity: 0;
}
.query__transition-leave-active {
  position: absolute;
  z-index: -1;
  transition: all 0.6s ease-out;
}

</style>
